import { svg } from "lit";
const icon = svg `<path d="M12 15.7884L7.7308 11.5193L8.78462 10.4347L11.25 12.9V4.5H12.7499V12.9L15.2153 10.4347L16.2692 11.5193L12 15.7884ZM4.5 19.5V14.9808H5.99997V18H18V14.9808H19.5V19.5H4.5Z" fill="currentColor"/>`;
export default icon;
